module.exports = __webpack_public_path__ + "static/media/facebook.79cb5675.svg";